import network from './index';

export const getAccount = () => {
  return network.get('/api/sugarcrm/account');
};

export const putAccount = (id) => {
  return network.put('/api/sugarcrm/account', id);
};